module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-h1"
  }, [_c('span', [_c('i', [_vm._v("EXPRESSIONS OF LOVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "part-h2"
  }, [_c('span', [_vm._v("A Novel")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left"
  }, [_vm._v("“When a woman loves a woman,")]), _vm._v(" "), _c('p', {
    staticClass: "part-left1"
  }, [_vm._v("it is the blood of the mothers speaking.”")]), _vm._v(" "), _c('p', {
    staticClass: "part-left"
  }, [_vm._v("—Caribbean proverb")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c426b77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 75
// module chunks = 0